import { render } from "./DashboardStart.vue?vue&type=template&id=4d24a060&scoped=true"
import script from "./DashboardStart.vue?vue&type=script&lang=js"
export * from "./DashboardStart.vue?vue&type=script&lang=js"

import "./DashboardStart.vue?vue&type=style&index=0&id=4d24a060&scoped=true&lang=css"
import "./DashboardStart.vue?vue&type=style&index=1&id=4d24a060&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d24a060"]])

export default __exports__